import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ContentPage } from 'src/app/enums/content-page.enum';
import { ContactService } from 'src/app/services/contact.service';
import { AlertComponent } from 'src/app/shared/alert/alert.component';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  contact = ContentPage.esES.contactanos;
  contactForm: FormGroup;
  textError: string;
  constructor(
    private contactservice: ContactService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    let language = localStorage.getItem('language');
    if (language == 'esEN') {
      this.contact = language == 'esEN' ? ContentPage.esEN.contactanos : ContentPage.esES.contactanos;
    };
    this.formBuilder();
  }

  formBuilder(){
    this.contactForm = new FormGroup({
      fullname: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      city: new FormControl('', Validators.required),
      request: new FormControl('', Validators.required),
      phone:new FormControl('', Validators.required)
    })
  }

  sendConsult(){
    if (!this.contactForm.valid) {
      this.textError = "Debe completar todos los campos oblitagorios con asterisco en rojo."
      return
    }

    this.textError = "";
    this.spinner.show();
    this.contactservice.sendConsult(this.contactForm.value).subscribe(
      (response)=>{
        this.contactForm.reset();
        this.formBuilder();
        this.dialog.open(AlertComponent,{
          autoFocus: false,
          width: '700px',
          data: {
            title: '¡Mensaje enviado con éxito!',
            text: 'El mensaje fue enviado correctamente, a la brevedad se contactará un representante.',
            textButton: 'Cerrar'
          }
        });
      },
      ()=>{},
      ()=>{
        this.spinner.hide();
      }
    );
  }

}
